const Logo = () => {

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={process.env.PUBLIC_URL + '/assets/images/logo.svg'} alt="Apollo" width="100" />
    );
};

export default Logo;
